var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15958_39018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20C13.5 20.825 12.825 21.5 12 21.5C11.175 21.5 10.5 20.825 10.5 20C10.5 19.175 11.175 18.5 12 18.5C12.825 18.5 13.5 19.175 13.5 20ZM13.5 5C13.5 5.825 12.825 6.5 12 6.5C11.175 6.5 10.5 5.825 10.5 5C10.5 4.175 11.175 3.5 12 3.5C12.825 3.5 13.5 4.175 13.5 5ZM13.5 12.5C13.5 13.325 12.825 14 12 14C11.175 14 10.5 13.325 10.5 12.5C10.5 11.675 11.175 11 12 11C12.825 11 13.5 11.675 13.5 12.5Z",
    fill: "#B0B0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15958_39018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 -1 0 24 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.0e35452f292fa7866a80375ad442d603.svg";
export { ForwardRef as ReactComponent };